import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageMeta } from '../hooks/usePageMeta';
import Hero from '../components/sections/Hero';
import StatsBar from '../components/sections/StatsBar';
import Philosophy from '../components/sections/Philosophy';
import Modalities from '../components/sections/Modalities';
import Services from '../components/sections/Services';
import Clients from '../components/sections/Clients';
import Contact from '../components/sections/Contact';

export default function Home() {
  const location = useLocation();
  // No title suffix on the homepage — usePageMeta(undefined, ...) falls
  // back to just the site name.
  usePageMeta(
    undefined,
    "PSI helps organizations identify not just what failed, but why it failed, and how to build the intelligence to prevent it. Six Sigma, Lean, and structured problem-solving training and consulting."
  );

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <>
      <Hero />
      <StatsBar />
      <Philosophy />
      <Modalities />
      <Services />
      <Clients />
      <Contact />
    </>
  );
}
